import creditCardUtils from 'creditcardutils';
import messages from './messages';
import { regexMap, cards } from './constants';
import { getExpiryYear, getExpiryMonth } from './helpers/expiry';

export const rules = {
    cardHolderName: function (creditCard) {
        return [
            {
                isValid: !regexMap.specialCharacters.test(creditCard.cardHolderName),
                message: messages.specialCharactersShort,
            },
        ];
    },
    creditCardNumber: function (creditCard, options) {
        const cardType = creditCardUtils.parseCardType(creditCard.creditCardNumber) || '';
        const maskedCardType =
            creditCardUtils.parseCardType(
                options.maskedCardNumber || creditCard.maskedCardNumber
            ) || '';
        const isValidCardNumber = creditCardUtils.validateCardNumber(creditCard.creditCardNumber);
        const isSupported = cards.includes(cardType);

        return [
            {
                isValid: isValidCardNumber && isSupported,
                message:
                    isValidCardNumber && !isSupported
                        ? messages.notSupportedCreditCard
                        : messages.creditCardNumber,
            },
            {
                isValid:
                    !(options.maskedCardNumber || creditCard.maskedCardNumber) ||
                    cardType === maskedCardType,
                message: messages[`creditCardTypeNumber.${maskedCardType}`],
            },
        ];
    },
    securityCode: function (creditCard) {
        const type = creditCardUtils.parseCardType(creditCard.creditCardNumber);
        const cvc = creditCard.securityCode;
        return [
            {
                isValid:
                    creditCardUtils.validateCardCVC(cvc, type) &&
                    (type !== 'amex' || cvc.length === 4),
                message: messages.securityCode,
            },
        ];
    },
    cardExpiry: function (creditCard) {
        const { cardExpiry = '' } = creditCard;
        const month = getExpiryMonth(cardExpiry) || '';
        const year = getExpiryYear(cardExpiry) || '';
        return [
            {
                isValid: creditCardUtils.validateCardExpiry(month, year),
                message: messages.cardExpiry,
            },
        ];
    },
};
